import { NavigationView } from '../../../shared/constants/navigation-view.enum.ts';

export type RelatoriosNavigationFlagsInput = {
  relatoriosAtividadesHabilitado: boolean;
  ehDefensorDiretor: boolean;
  authVisao: NavigationView | null;
  assessorPodeEditarRelatorio: boolean;
  suporteRelatorios: boolean;
  perfilRelatoriosDefensor: boolean;
};

export type RelatoriosNavigationFlags = {
  relatoriosAtividades: boolean;
  relatoriosDiretoria: boolean;
  relatoriosCorregedoria: boolean;
};

/** Flags de menu de relatórios a partir de visão/perfil (sem carregar permissões do storage). */
export function buildRelatoriosNavigationFlags(
  input: RelatoriosNavigationFlagsInput,
): RelatoriosNavigationFlags {
  const {
    relatoriosAtividadesHabilitado,
    ehDefensorDiretor,
    authVisao,
    assessorPodeEditarRelatorio,
    suporteRelatorios,
    perfilRelatoriosDefensor,
  } = input;

  return {
    relatoriosAtividades:
      relatoriosAtividadesHabilitado &&
      authVisao !== NavigationView.Estagiario &&
      (suporteRelatorios || perfilRelatoriosDefensor || assessorPodeEditarRelatorio),
    relatoriosDiretoria:
      relatoriosAtividadesHabilitado &&
      authVisao !== NavigationView.GestorRelatorios &&
      (ehDefensorDiretor || suporteRelatorios),
    relatoriosCorregedoria:
      relatoriosAtividadesHabilitado &&
      (authVisao === NavigationView.Corregedoria ||
        authVisao === NavigationView.GestorRelatorios ||
        suporteRelatorios),
  };
}
